import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import axiosApiInstance from 'commons/utils/axios';

import { EApiBalance } from '../types/add-credit';
import { NuvemPagoBalanceResponseDto } from '../types/get-balance-response-dto';

export const getNuvemPagoBalance =
  async (): Promise<NuvemPagoBalanceResponseDto> => {
    const response = await axiosApiInstance.get(
      '/statement/nuvem-pago/balance'
    );

    return response?.data;
  };

export const useNuvemPagoBalance = (
  options?: UseQueryOptions<NuvemPagoBalanceResponseDto, Error>
) => {
  return useQuery({
    queryKey: [EApiBalance.NUVEM_PAGO_BALANCE],
    queryFn: getNuvemPagoBalance,
    retry: false,
    ...options
  });
};
